/**
 * Theme-based row status colors for tables.
 * Uses Metronic theme colors for consistent UI.
 */
export const ROW_STATUS_COLORS = {
  // Active/Success states
  active: '#e8fbf8',    // soft success-light (cleaner tint)
  approved: '#e8fbf8',  // soft success-light
  valid: '#e8fbf8',     // soft success-light
  '0': '#e8fbf8',
  0: '#e8fbf8',

  // Pending/Warning states
  pending: '#FFF4DE',   // warning-light
  '1': '#FFF4DE',       // note: for businesses pending is 1
  1: '#FFF4DE',

  // Info states
  moreinfo: '#EEE5FF',   // info-light
  '4': '#EEE5FF',
  4: '#EEE5FF',

  // Inactive/Danger states
  inactive: '#FFE2E5',   // danger-light
  rejected: '#FFE2E5',   // danger-light
  invalid: '#FFE2E5',   // danger-light
  expired: '#FFE2E5',   // danger-light
  '2': '#FFE2E5',
  2: '#FFE2E5',

  // Draft / Neutral states
  draft: '#F3F6F9',
  '5': '#F3F6F9',
  5: '#F3F6F9',

  // Default
  default: '#ffffff',
};

/**
 * Returns row style object for react-bootstrap-table based on status field.
 * @param {Object} row - Table row data
 * @param {string} statusField - Name of status field (default: 'status')
 * @param {Object} statusMap - Optional map of status values to colors
 */
export function getRowStyleByStatus(row, statusField = 'status', statusMap = ROW_STATUS_COLORS) {
  try {
    if (!row || typeof row !== 'object') return { backgroundColor: '#ffffff' };
    const map = statusMap || ROW_STATUS_COLORS;
    const rawStatus = row[statusField];
    if (rawStatus === undefined || rawStatus === null || rawStatus === '') {
      return { backgroundColor: map.default || '#ffffff' };
    }

    // Handle boolean / number / string safely
    const statusStr = String(rawStatus).trim().toLowerCase();

    // If status is a location/category status (0 = active, 1 = inactive)
    if (statusField === 'status' && (statusStr === '1' || rawStatus === 1)) {
      const isInactive = map[statusStr] || map.inactive;
      return { backgroundColor: isInactive || '#FFE2E5' };
    }
    if (statusField === 'status' && (statusStr === '0' || rawStatus === 0)) {
      const isActive = map[statusStr] || map.active;
      return { backgroundColor: isActive || '#e8fbf8' };
    }

    const backgroundColor = map[statusStr] || map[rawStatus] || map.default || '#ffffff';
    return { backgroundColor };
  } catch (e) {
    return { backgroundColor: '#ffffff' };
  }
}
